/* DeviceStatusComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
const Renderer = require("./DeviceStatusRenderer");
const _ = require("lodash");

class DeviceStatusColumnComponent extends EventEmitter {
    constructor(deviceEntity) {
        super();

        this._device = deviceEntity;
        this._labels = this._device.getDeviceStatusLabels();
        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */

    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */

    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._device = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setDeviceState(newVal);
        }
    }

    getValue() {
        return {
            deviceEntity: this.getDeviceState()
        };
    }

    setDeviceState(newVal) {
        this.emit("DeviceState", newVal);
        return this;
    }

    getDeviceState() {
        return this._device;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = DeviceStatusColumnComponent;
